export default "__VITE_PUBLIC_ASSET__99ebedab__"